import { Instance, types, flow } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";
import { SkuListVo } from "@/app/csr-src/apis/afterSales/afterSales.interface";

export const AfterSalesStoreModel = types
  .model("AfterSalesStore")
  .props({
    selectedProductList: types.optional(types.frozen(), []),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    setSelectedProductList(list: SkuListVo[]) {
      self.selectedProductList = list;
    },
  }));

export interface OrdersStoreModel extends Instance<typeof AfterSalesStoreModel> {}
